/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

.qds-icon {
  flex-shrink: 0;
  height: 1.25em;
  width: 1.25em;
}

.qds-inline-link {
  align-items: center;
  border-radius: var(--qds-focus-border-radius);
  display: inline-flex;
  gap: var(--qds-text-icon-gap);
  max-width: inherit;
  width: inherit;

  &:focus-visible {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }
}

.qds-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qds-disabled {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

[data-importance='subdued'] {
  color: var(--qds-theme-link-subdued-default);

  &:visited {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-subdued-hover);
  }

  &:active {
    color: var(--qds-theme-link-subdued-pressed);
  }

  &:visited:hover {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='standard'] {
  color: var(--qds-theme-link-standard-default);

  &:visited {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-standard-hover);
  }

  &:active {
    color: var(--qds-theme-link-standard-pressed);
  }

  &:visited:hover {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active {
    color: var(--qds-theme-link-visited-pressed);
  }
}

[data-importance='emphasized'] {
  color: var(--qds-theme-link-emphasized-default);

  &:visited {
    color: var(--qds-theme-link-visited-default);
  }

  &:hover {
    color: var(--qds-theme-link-emphasized-hover);
  }

  &:active {
    color: var(--qds-theme-link-emphasized-pressed);
  }

  &:visited:hover {
    color: var(--qds-theme-link-visited-hover);
  }

  &:visited:active {
    color: var(--qds-theme-link-visited-pressed);
  }
}
